import { CreateDevice } from "./createDevice";

export class DeliveryDevices {
    companyId:number;
    companyPersonId:number;
    kindId:number;
    appUserId:number;
    createDevices?:CreateDevice[];
    selectedDevices?:number[];
    description?:string;
    movementDate:Date;
}